/**
 * Hook per la risoluzione del canale di vendita Store.
 *
 * Priorità: hostname (sottodominio partner) > ?ref= query param > localStorage.
 * Chiama GET /api/store/channel-info/?ref=<codice> per risolvere il canale.
 */
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';

const CHANNEL_KEY = 'asight_channel';
const API_BASE = process.env.REACT_APP_API_URL || '';

/**
 * Estrae il codice referral dal sottodominio (es. 'cna' da 'cna.a-sight.io').
 * Ritorna null per sottodomini di sistema (mssp, panel, api, enterprise, reseller, www).
 */
function getHostRef() {
  const hostname = window.location.hostname.toLowerCase();
  const systemSubdomains = ['a-sight', 'mssp', 'panel', 'api', 'enterprise', 'reseller', 'www'];
  const match = hostname.match(/^([^.]+)\.a-sight\.io$/);
  if (match && !systemSubdomains.includes(match[1])) {
    return match[1];
  }
  return null;
}

export function useChannel() {
  const [searchParams] = useSearchParams();
  const [channelInfo, setChannelInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  // Priorità: hostname > ?ref= query param
  const hostRef = useMemo(() => getHostRef(), []);
  const ref = hostRef || searchParams.get('ref') || '';

  useEffect(() => {
    if (ref) {
      localStorage.setItem(CHANNEL_KEY, ref);
    } else {
      localStorage.removeItem(CHANNEL_KEY);
      setChannelInfo({ valid: false, channel_type: 'DIRETTO' });
      setLoading(false);
      return;
    }

    // Chiama API per risolvere il canale
    axios
      .get(`${API_BASE}/api/store/channel-info/?ref=${encodeURIComponent(ref)}`)
      .then((res) => {
        setChannelInfo(res.data);
        if (!res.data.valid) {
          localStorage.removeItem(CHANNEL_KEY);
        }
      })
      .catch(() => {
        setChannelInfo({ valid: false, channel_type: 'DIRETTO' });
        localStorage.removeItem(CHANNEL_KEY);
      })
      .finally(() => setLoading(false));
  }, [ref]);

  return { channelInfo, loading, codiceCanale: ref };
}

export { getHostRef };
export default useChannel;
